// extracted by mini-css-extract-plugin
export default {"modalOverlay":"rD-z","modalContent":"sD-z","header":"tD-z","close":"uD-z"};